export function getFirstColorRate(inverse: boolean): string {
  return inverse ? 'green' : 'red';
}

export function getSecondColorRate(inverse: boolean): string {
  return inverse ? 'blue' : 'yellow';
}

export function getThirdColorRate(inverse: boolean): string {
  return getSecondColorRate(!inverse);
}

export function getForthColorRate(inverse: boolean): string {
  return getFirstColorRate(!inverse);
}

export function getColorByValue(value: number, inverse?: boolean): string {
  switch (true) {
    case value >= 1 && value < 15: {
      return getFirstColorRate(!!inverse);
    }
    case value >= 15 && value < 50: {
      return getSecondColorRate(!!inverse);
    }
    case value >= 50 && value < 75: {
      return getThirdColorRate(!!inverse);
    }
    case value >= 75 && value <= 100: {
      return getForthColorRate(!!inverse);
    }
    default: {
      return '';
    }
  }
}
